<template>
  <Layout>
    <PageHeader :title="title" :breadcrumbs="breadcrumbs" />
    <task-details :task="taskDetails"/>
    <task-ready-to-assign
      v-if="taskDetails.state === 'READY_TO_ASSIGN'"
      :taskId="taskDetails.id"
      :taskTitle="taskDetails.title"
      @assignTask="assignTaskMethod($event)"
    />
    <task-assigned
      v-else-if="taskDetails.state === 'ASSIGNED'"
      :taskId="taskDetails.id"
      @completeTask="completeTaskMethod()"
    />
    <task-completed
      v-else-if="taskDetails.state === 'COMPLETED'"
      :taskId="taskDetails.id"
    />
    <div v-else-if="taskDetails.state !== 'CANCELED'">
      <b-table
          :items="talentsWithStatus"
          :fields="tableFields"
          responsive="sm"
      >
        <template #cell(name)="talent">
          {{ talent.item.lastName }}, {{ talent.item.firstName }}
        </template>
        <template #cell(state)="talent">
          {{ getBeautifiedTaskState(talent.item.state) }}
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col-10">
        <button @click="$router.go(-1)" type="button" class="btn btn-secondary m-2">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
          {{ $t("go-back") }}
        </button>
      </div>
    </div>
  </Layout>
</template>

<script>
import i18n from '@/i18n';
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import TaskDetails from "@/router/views/tasks/partials/task-details";
import TaskAssigned from "@/router/views/tasks/partials/task-assigned";
import TaskReadyToAssign from "@/router/views/tasks/partials/task-ready-to-assign";
import TaskCompleted from "@/router/views/tasks/partials/task-completed";
import { taskService } from "@/helpers/services/tasks/taskService";


export default {
  name: "TaskStatus",
  components: {
    PageHeader,
    Layout,
    TaskDetails,
    TaskReadyToAssign,
    TaskAssigned,
    TaskCompleted,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      title: i18n.t("tasks.status.title"),
      breadcrumbs: [
        {text: i18n.t("tasks.overview.title"), href: "/tasks"},
        {text: i18n.t("tasks.status.title"), active: true},
      ],
      taskDetails: {},
      talentsWithStatus: {},
      tableFields: [
        { key: "name", label: i18n.t("talents.form.name") },
        { key: "department", label: i18n.t("talents.form.department") },
        { key: "state", label: i18n.t("tasks.talents-table.form.state") },
      ],
    };
  },
  methods: {
    assignTaskMethod({assigneeIds}) {
      taskService.assignTask(this.taskDetails, assigneeIds);
    },
    completeTaskMethod() {
      taskService.completeTask(this.taskDetails);
    },
    getBeautifiedTaskState(state) {
      return i18n.t(`tasks.${state.toLowerCase()}`).toString();
    }
  },
  created() {
    taskService.fetchTaskDetails(this.id)
      .then(td => this.taskDetails = td);
    taskService.fetchTaskTalents(this.id)
        .then(td => this.talentsWithStatus = td);
  },
};
</script>

<style lang="scss" scoped>
  h2 {
    margin-top: 10px;
  }
</style>